<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M20.879 48.879c-1.172 1.171-1.172 3.07 0 4.242 1.171 1.172 3.07 1.172 4.242 0l18-18c1.172-1.171 1.172-3.07 0-4.242l-18-18c-1.171-1.172-3.07-1.172-4.242 0-1.172 1.171-1.172 3.07 0 4.242L36.757 33 20.88 48.879z" transform="translate(-786 -751) translate(786 751) rotate(90 32 33)"/>
            </g>
        </g>
    </g>
</svg>
